import React from "react";
import { Helmet } from "react-helmet";
import markt from "../assets/markt.jpg";
import Contactfooter from "./contactfooter";
import ContactComponent from "./ContactComponent";
import image1 from "../assets/carousel/image1.webp";
import image2 from "../assets/carousel/image2.webp";
import image3 from "../assets/carousel/image3.webp";
import image4 from "../assets/carousel/image4.webp";
import digitalMarkt from "../assets/services/digitalMarkt.jpg";
import ppc from "../assets/services/ppc.png";
import seo from "../assets/services/seo.png";

const imageData = [
  {
    src: image1,
    text: "We provide top-notch web development services tailored to your business needs.",
  },
  {
    src: image2,
    text: "Our e-commerce solutions help businesses establish a strong online presence.",
  },
  {
    src: image3,
    text: "Experience stunning web designs that enhance user engagement and experience.",
  },
  {
    src: image4,
    text: "Responsive and mobile-friendly designs to ensure accessibility on all devices.",
  },
];

const Marketing = () => {
  return (
    <>
      <Helmet>
        <title>Digital Marketing | theKrisoft</title>
        <meta
          name="description"
          content="The Krisoft provides top-notch digital marketing solutions, ensuring brand visibility and customer engagement."
        />
        <meta
          name="keywords"
          content="digital marketing, SEO, social media marketing, The Krisoft, online advertising, brand awareness"
        />
        <meta name="author" content="The Krisoft" />
      </Helmet>

      <div
        className=" bg-cover bg-center relative flex items-center justify-center md:justify-end"
        style={{ backgroundImage: `url(${markt})`, height: "80vh"  }}
      >
        <div className="w-full max-w-xs bg-[rgba(255,255,255,0.8)] p-4 rounded-lg shadow-lg mx-auto md:mx-0 md:mr-16 md:max-w-sm">
          <ContactComponent />
        </div>
      </div>

      {/* information content */}
      {/* first content */}
      <div className="mx-auto">
        <div className="bg-gray-200 p-5">
          <p className="text-4xl text-center">Digital Marketing</p>
          <hr className="bg-orange-700 h-1 w-40 mx-auto my-2" />
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/digital-marketing-concept-illustration_114360-1877.jpg"
                alt="Digital Marketing Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Digital Marketing
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>SEO optimization for better search ranking.</li>
                <li>Social media marketing strategies.</li>
                <li>Email marketing campaigns for conversions.</li>
                <li>Paid advertising (PPC, Google Ads, Facebook Ads).</li>
                <li>Content marketing and brand storytelling.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section 2: Social Media Strategy */}
        <div className="bg-gray-300 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Social Media Strategy
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Creating engaging content for various platforms.</li>
                <li>Analyzing audience insights and engagement metrics.</li>
                <li>Influencer marketing collaborations.</li>
                <li>Developing consistent branding and voice.</li>
                <li>Measuring success with analytics tools.</li>
              </ul>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/social-media-marketing-concept-illustration_114360-1289.jpg"
                alt="Social Media Marketing Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
          </div>
        </div>

        {/* Section 3: Paid Advertising */}
        <div className="bg-gray-200 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/ppc-marketing-concept-illustration_114360-7287.jpg"
                alt="PPC Advertising Illustration"
                className="w-full max-w-md animate-moveUpDown h-80"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Paid Advertising
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Google Ads, Facebook Ads, and Instagram Ads.</li>
                <li>Budget management for high ROI.</li>
                <li>Audience targeting and ad personalization.</li>
                <li>Retargeting strategies for conversions.</li>
                <li>Analyzing ad performance with real-time data.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className=" bg-[#FAEBCC] p-4">
        <div className="mt-9 mb-11 md:mt-16">
          <h3 className="text-center text-3xl text-red-800 font-bold mb-6">
            <span className="font-dancing pr-4 text-4xl ">Our Serives</span>
            Digital Marketing
          </h3>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto mb-14" />
          <div className="flex flex-wrap gap-4 mt-10 justify-center">
            <div className="flex flex-col items-center">
              <img
                src={digitalMarkt}
                alt="reactNative"
                className="shadow-md w-28 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
              />
              <p className="mt-2 text-sm font-medium text-gray-700">
                Digital Marketing
              </p>
            </div>
            <div className="flex flex-col items-center">
              <img
                src={ppc}
                alt="flutter"
                className="shadow-md w-28 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
              />
              <p className="mt-2 text-sm font-medium text-gray-700">
                Pay Per Click
              </p>
            </div>
            <div className="flex flex-col items-center">
              <img
                src={seo}
                alt="seo"
                className="shadow-md w-28 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
              />
              <p className="mt-2 text-sm font-medium text-gray-700">SEO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center px-6 py-10">
        <h1 className="text-4xl font-bold">
          Benefits of Website Development with The Krisoft
        </h1>
        <p className="mt-6 text-lg">
          We offer comprehensive web design services in Mumbai and beyond,
          working closely with clients to ensure their website aligns with
          business goals.
        </p>
      </div>

      <div className="w-4/5 mx-auto py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {imageData.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <img
              src={item.src}
              alt="Web Development Service"
              className="w-40 h-auto rounded-lg mb-4 shadow-md"
            />
            <p className="text-sm text-gray-600">{item.text}</p>
          </div>
        ))}
      </div>
      <Contactfooter />
      {/* Tailwind CSS Keyframe Animation */}
      <style>
        {`
          @keyframes moveUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }
          .animate-moveUpDown {
            animation: moveUpDown 2s ease-in-out infinite;
          }
        `}
      </style>
    </>
  );
};

export default Marketing;
